import { RegulatedCompanyDocumentsTypes } from './types';
import ApplicationDocuments from '../../common/documents/documents';

const RegulatedCompanyDocuments = ({
  documents,
  applicationId,
  applicationStatus,
  search,
  allowedDocumentsCategories,
  errors,
  clearErrors,
  renameAvailable,
  isCof,
}: RegulatedCompanyDocumentsTypes) => (
  <ApplicationDocuments
    zIndex={10}
    isCof={isCof}
    applicationStatus={applicationStatus}
    applicationId={applicationId}
    documents={documents}
    allowedDocumentsCategories={allowedDocumentsCategories}
    errors={errors}
    clearErrors={clearErrors}
    search={search}
    renameAvailable={renameAvailable}
  />
);

export default RegulatedCompanyDocuments;
